import { Button } from "@mui/material";
import { useState } from "react";

import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from "@mui/material";
import { Box } from "@mui/system";
import {
  notifyOperator,
  postChangeChapterTime,
  postChangeReferencesTime
} from "../../Operator/OperatorAPI/OperatorPost";

const UserTimingDialog = ({ onClose, user }) => {
  const [minutesSkip, setMinutesSkip] = useState(0);
  const [error, setError] = useState(null);
  const [sending, setSending] = useState(false);

  // "chapter" | "references"
  const changeTime = async (section, shouldIncrease) => {
    if (!minutesSkip || minutesSkip <= 0) {
      setError("יש להזין מספר דקות חיובי");
      return;
    }

    setError(null);
    setSending(true);
    const post = section === "chapter" ? postChangeChapterTime : postChangeReferencesTime;
    const result = await post(user.id, minutesSkip, shouldIncrease);
    setSending(false);

    if (!result.ok) {
      // Keep the dialog open with the reason, so the operator can pick a different action.
      setError(result.error);
      return;
    }

    const sectionLabel = section === "chapter" ? "הפרק" : "דף ההפניות";
    notifyOperator(
      `${shouldIncrease ? "נוספו" : "הופחתו"} ${minutesSkip} דקות ל${sectionLabel} של ${user.name}`,
      "success"
    );
    onClose();
  };

  return (
    <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth={true}>
      <DialogTitle>{`Change timing for ${user?.name}`}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Add or remove time from the section {user?.name} is currently in.
        </DialogContentText>
        <Box marginTop={3}>
          <TextField
            label="Minutes"
            type="number"
            value={minutesSkip}
            onChange={event => {
              setMinutesSkip(Number(event.target.value));
              setError(null);
            }}
            inputProps={{ min: 0 }}
          />
        </Box>
        {error && (
          <Alert severity="warning" sx={{ mt: 2 }} dir="rtl">
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button disabled={sending} onClick={() => changeTime("chapter", true)} color="primary">
          Extend Chapter
        </Button>
        <Button disabled={sending} onClick={() => changeTime("chapter", false)} color="primary">
          Reduce Chapter
        </Button>
        <Button disabled={sending} onClick={() => changeTime("references", true)} color="primary">
          Extend References
        </Button>
        <Button disabled={sending} onClick={() => changeTime("references", false)} color="primary">
          Reduce References
        </Button>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default UserTimingDialog;
